import { render, staticRenderFns } from "./report-pdf-page.vue?vue&type=template&id=4bba63db&scoped=true"
import script from "./report-pdf-page.vue?vue&type=script&lang=js"
export * from "./report-pdf-page.vue?vue&type=script&lang=js"
import style0 from "./report-pdf-page.vue?vue&type=style&index=0&id=4bba63db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bba63db",
  null
  
)

export default component.exports